import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  BarChart2,
  Target,
  PenTool,
  RefreshCw,
  Search,
  Mail,
  Share2,
  Users,
  TrendingUp,
} from "react-feather";
import "bootstrap/dist/css/bootstrap.min.css";
import img121 from "../../assets/image/digital/analysis_17122639.gif";
import img122 from "../../assets/image/digital/content_19008672.gif";
import img123 from "../../assets/image/digital/user_8819071.gif";
import img124 from "../../assets/image/digital/growth_16045894.gif";
import img125 from "../../assets/image/digital/bar-chart_7211812.gif";
import Footer from "../Footer/Footer";
import DigiOne from "../../assets/image/digital/digi-1.jpg";
import DigiTwo from "../../assets/image/digital/digi-2.jpg";
import DigiThree from "../../assets/image/digital/digi-3.jpg";
import DigiFour from "../../assets/image/digital/digi-4.jpg";
import "../../assets/css/digital.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";
const DigitalMarketingPage = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const Gamedevelopment = data[0]?.services_page_Digital_Marketing;

    if (Gamedevelopment) {
      setMeta(Gamedevelopment);
    }
  }, []);
  const [activeStep, setActiveStep] = useState(1);

  const processSteps = [
    {
      id: 1,
      title: "Discovery & Strategy",
      description:
        "Deep dive into your business, audience, and goals to develop a tailored strategy",
      image: DigiOne,
    },
    {
      id: 2,
      title: "Campaign Development",
      description:
        "Creative development and technical implementation of marketing campaigns",
      image: DigiTwo,
    },
    {
      id: 3,
      title: "Execution & Optimization",
      description:
        "Launch campaigns and continuously optimize based on performance data",
      image: DigiThree,
    },
    {
      id: 4,
      title: "Analysis & Reporting",
      description:
        "Measure results, analyze performance, and refine future strategies",
      image: DigiFour,
    },
  ];

  const handleStepClick = (stepId) => {
    setActiveStep(stepId);
  };

  // Digital Marketing Solutions
  const marketingSolutions = [
    {
      id: 1,
      title: "Integrated Marketing Strategies",
      description:
        "Combining SEO, PPC, social media, email, and content into a cohesive approach",
      icon: (
        <img
          src={img125}
          alt="Analytics Icon"
          style={{ width: 74, height: 74 }}
        />
      ),
      features: [
        "Multi-channel campaign strategy",
        "SEO optimization",
        "PPC advertising management",
        "Social media marketing",
        "Email campaign execution",
      ],
    },
    {
      id: 2,
      title: "Advanced Analytics & Reporting",
      description:
        "Monitoring performance and maximizing ROI with cutting-edge tools",
      icon: (
        <img
          src={img121}
          alt="Analytics Icon"
          style={{ width: 74, height: 74 }}
        />
      ),
      features: [
        "Google Analytics implementation",
        "SEMrush competitive analysis",
        "HubSpot integration",
        "ROI-focused reporting",
        "Performance dashboards",
      ],
    },
    {
      id: 3,
      title: "Creative Content Development",
      description: "Producing engaging content that differentiates your brand",
      icon: (
        <img
          src={img122}
          alt="Analytics Icon"
          style={{ width: 74, height: 74 }}
        />
      ),
      features: [
        "Brand storytelling",
        "Content strategy development",
        "Video production",
        "Blog and article creation",
        "Visual content design",
      ],
    },
    {
      id: 4,
      title: "Targeted Audience Engagement",
      description: "Reaching the right audience at the optimal time",
      icon: (
        <img
          src={img123}
          alt="Analytics Icon"
          style={{ width: 74, height: 74 }}
        />
      ),
      features: [
        "Audience segmentation",
        "Persona development",
        "Behavioral targeting",
        "Retargeting campaigns",
        "Timing optimization",
      ],
    },
    {
      id: 5,
      title: "Continuous Optimization",
      description:
        "Enhancing campaign effectiveness through testing and refinement",
      icon: (
        <img
          src={img124}
          alt="Analytics Icon"
          style={{ width: 74, height: 74 }}
        />
      ),
      features: [
        "A/B testing implementation",
        "Retargeting campaigns",
        "Performance tracking",
        "Conversion rate optimization",
        "Iterative improvements",
      ],
    },
  ];

  // Marketing Features
  const features = [
    {
      icon: <Search size={40} />,
      title: "Search Engine Visibility",
      description:
        "Boost your website's ranking and drive organic traffic with our comprehensive SEO strategies.",
    },
    {
      icon: <Mail size={40} />,
      title: "Email Campaigns",
      description:
        "Engage your audience with personalized email marketing that converts.",
    },
    {
      icon: <Users size={40} />,
      title: "Social Media Management",
      description:
        "Build brand loyalty and engagement through strategic social media presence.",
    },
    {
      icon: <TrendingUp size={40} />,
      title: "ROI-Focused Strategies",
      description:
        "Data-driven campaigns designed to maximize your return on investment.",
    },
  ];

  // Marketing Tools
  const marketingTools = [
    {
      title: "Analytics & Insights",
      icon: "📊",
      tools: ["Google Analytics", "Mixpanel", "Google Data Studio", "Hotjar"],
      description: "Comprehensive data analysis for informed decision-making",
    },
    {
      title: "SEO & Content",
      icon: "🔍",
      tools: ["SEMrush", "Ahrefs", "Moz", "BuzzSumo"],
      description: "Tools to optimize content and improve search visibility",
    },
    {
      title: "Advertising Platforms",
      icon: "📢",
      tools: ["Google Ads", "Facebook Ads", "LinkedIn Ads", "Twitter Ads"],
      description: "Multi-channel advertising solutions",
    },
    {
      title: "Automation & CRM",
      icon: "🤖",
      tools: ["HubSpot", "Mailchimp", "ActiveCampaign", "Salesforce"],
      description: "Streamline marketing operations and customer relationships",
    },
  ];

  // Reusable Card Component
  const CardComponent = ({ service }) => (
    <div
      className="p-4 rounded-4 shadow-sm w-100 h-100 d-flex flex-column bg-white"
      style={{
        borderTop: `4px solid ${service.color}`,
      }}
    >
      <div className="d-flex align-items-center mb-3">
        <div
          className="rounded-circle d-flex align-items-center justify-content-center me-3"
          style={{
            width: "50px",
            height: "50px",
            backgroundColor: `${service.color}20`,
            color: service.color,
            flexShrink: 0,
          }}
        >
          {service.icon}
        </div>
        <h3 className="h5 fw-bold mb-0 text-break">{service.title}</h3>
      </div>

      <p className="mb-3">{service.description}</p>

      <ul className="list-unstyled mb-0 mt-auto">
        {service.features.map((feature, idx) => (
          <li key={idx} className="d-flex align-items-start mb-2">
            <span className="me-2 text-success">✓</span>
            <span className="fw-medium text-dark">{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelmetProvider>
      <div className="digital-marketing-page">
        <Helmet>
          <title>
            {meta?.title || "Services-Digital_Marketing - SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED"}
          </title>
          <meta
            name="description"
            content={meta?.meta?.meta1?.content || "Our curriculum."}
          />
        </Helmet>
        {/* Hero Section */}
        <div className="position-relative digital-bg bg-light text-dark overflow-hidden min-vh-50 d-flex align-items-center">
          <div className="position-absolute top-0 start-0 w-100 h-100 opacity-20"></div>
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col-lg-6 casino-content">
                <nav aria-label="breadcrumb" className="mb-4">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item"
                      aria-current="page"
                    >
                      Digital Marketing
                    </li>
                  </ol>
                </nav>
                <h3 className="display-5 fw-bold mb-3"> Digital Marketing</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Solutions Section */}
        <section className="py-2" style={{ marginTop: "30px" }}>
          <Container>
            <Row className="justify-content-center mb-`">
              <Col lg={8} className="text-center">
                <button
                  className="btn border border-danger fw-semibold bg-transparent px-3 py-1 rounded-pill mb-3 fs-6 fs-md-5"
                  style={{ color: "#41C1EE" }}
                >
                  OUR SOLUTIONS
                </button>
                <h3 className="display-5 fw-bold mb-2">
                  Our Digital Marketing
                  <span className="font-red">Solutions</span>
                </h3>
                <p className="font-para">
                  Comprehensive strategies that transform your online presence
                  into a powerful engine for lead generation, brand building,
                  and revenue growth.
                </p>
              </Col>
            </Row>

            <Row className="g-4 justify-content-center">
              {marketingSolutions.map((service, index) => (
                <Col
                  key={service.id}
                  xs={12}
                  md={6}
                  lg={index < 3 ? 4 : 5}
                  className="d-flex justify-content-center"
                >
                  <CardComponent service={service} />
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Results Section */}
        <section className="py-4 bg-light" style={{ marginTop: "20px" }}>
          <Container fluid className="px-5">
            <Row className="align-items-start flex-column-reverse flex-lg-row">
              {/* LEFT SIDE: Text + Cards + Button */}
              <Col lg={6} className="order-2 order-lg-1">
                <h3 className="display-5 fw-bold mb-3 text-center text-lg-start">
                  Measurable Results That{" "}
                  <span className="font-red">Drive Growth</span>
                </h3>
                <p className="font-para mb-4 text-center text-lg-start">
                  Our data-driven approach ensures every campaign delivers
                  tangible business outcomes. We focus on KPIs that matter to
                  your bottom line.
                </p>

                {/* Cards Grid */}
                <div
                  className="d-grid gap-3 mb-4"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                  }}
                >
                  {[
                    { value: "73%", text: "Avg. Increase in Qualified Leads" },
                    {
                      value: "45%",
                      text: "Reduction in Customer Acquisition Cost",
                    },
                    { value: "3.5x", text: "Return on Marketing Investment" },
                    {
                      value: "89%",
                      text: "Client Retention Rate on Marketing cost",
                    },
                  ].map((stat, index) => (
                    <div
                      key={index}
                      className="stat-card p-3 rounded-3 shadow-sm d-flex flex-column justify-content-center align-items-center text-center"
                      style={{ minHeight: "150px" }}
                    >
                      <div className="display-6 fw-bold font-red">
                        {stat.value}
                      </div>
                      <div className="text-dark fw-medium small mt-2">
                        {stat.text}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="text-center text-lg-start">
                  <button className="btn bg-red text-white fw-semibold px-4 py-2">
                    See Case Studies
                  </button>
                </div>
              </Col>

              {/* RIGHT SIDE: Graph */}
              <Col lg={6} className="order-1 order-lg-2 mb-4 mt-3 mb-lg-0">
                <div className="results-graph p-4 rounded-3 shadow-sm bg-light h-100">
                  <div className="d-flex justify-content-between mb-4">
                    <div>
                      <h3 className="h5 fw-bold mb-1">Campaign Performance</h3>
                      <p className="font-black fw-semibold small mb-0">
                        Last 6 months
                      </p>
                    </div>
                    <div className="text-success fw-bold">+42% Growth</div>
                  </div>

                  <div
                    className="graph-visualization d-flex align-items-end gap-2 mb-2"
                    style={{ height: "200px" }}
                  >
                    {[
                      "#f9c1c3",
                      "#f28a8e",
                      "#eb5359",
                      "#e52b32",
                      "#41C1EE",
                      "#b8191f",
                    ].map((color, i) => (
                      <div
                        key={i}
                        className="graph-bar w-100"
                        style={{
                          height: `${80 + i * 20}px`,
                          backgroundColor: color,
                        }}
                      ></div>
                    ))}
                  </div>

                  <div className="d-flex justify-content-between">
                    <span>Jan</span>
                    <span>Feb</span>
                    <span>Mar</span>
                    <span>Apr</span>
                    <span>May</span>
                    <span>Jun</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Features Section */}
        <section
          className="py-3 bg-gradient-light"
          style={{ marginTop: "20px" }}
        >
          <Container>
            <Row className="justify-content-center mb-5">
              <Col lg={8} className="text-center">
                <h3 className="display-6 fw-bold mb-3">
                  Comprehensive Marketing
                  <span className="font-red"> Capabilities</span>
                </h3>
                <p className="font-para mb-4">
                  We combine creative storytelling with cutting-edge marketing
                  technologies to deliver campaigns that resonate with your
                  target audience.
                </p>
              </Col>
            </Row>

            <Row className="g-4">
              {features.map((feature, index) => (
                <Col lg={3} md={6} key={index}>
                  <div className="feature-card h-100 p-4 rounded-3 bg-white shadow-sm text-center">
                    <div className="icon-container mx-auto mb-4 rounded-circle d-flex align-items-center justify-content-center">
                      {feature.icon}
                    </div>
                    <h3 className="h5 fw-bold mb-3">{feature.title}</h3>
                    <p className="text-dark fw-medium">{feature.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Process Section */}
        {/* <section className="py-4 bg-light" style={{ marginTop: "60px" }}>
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h3 className="display-5 fw-bold mb-3">
                Our Proven Marketing Process
              </h3>
              <p className="text-dark fw-semibold fs-5 mb-4">
                A systematic approach to ensure your digital marketing success
              </p>
            </Col>
          </Row>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4 className="fw-bold">Discovery & Strategy</h4>
                <p>
                  Deep dive into your business, audience, and goals to develop a
                  tailored strategy
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4 className="fw-bold">Campaign Development</h4>
                <p>
                  Creative development and technical implementation of marketing
                  campaigns
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4 className="fw-bold">Execution & Optimization</h4>
                <p>
                  Launch campaigns and continuously optimize based on
                  performance data
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h4 className="fw-bold">Analysis & Reporting</h4>
                <p>
                  Measure results, analyze performance, and refine future
                  strategies
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section> */}

        <section className="bg-light" style={{ marginTop: "20px" }}>
          <div className="container py-5">
            {/* Heading Section */}
            <div className="row justify-content-center mb-4">
              <div className="col-lg-8 text-center">
                <h3 className="display-6 fw-bold mb-3">
                  Our Proven Marketing <span className="font-red">Process</span>
                </h3>
                <p className="font-para mb-3">
                  A systematic approach to ensure your digital marketing success
                </p>
              </div>
            </div>

            {/* Main Content Section */}
            <div className="row align-items-start">
              {/* Left: Steps */}
              <div className="col-12 col-md-12 col-lg-6 mb-4 mb-md-0">
                <div className="digital-process-step">
                  {processSteps.map((step) => (
                    <div
                      key={step.id}
                      className={`digital-process-step mb-3 p-3 rounded shadow-sm ${
                        activeStep === step.id
                          ? "active border border-danger"
                          : ""
                      }`}
                      onClick={() => handleStepClick(step.id)}
                      style={{ cursor: "pointer", backgroundColor: "#f8f9fa" }}
                    >
                      {/* Responsive vertical alignment: start on tablet, center on desktop */}
                      <div className="d-flex align-items-start align-items-lg-center">
                        {/* Step Number */}
                        <div
                          className="step-number me-3 fw-bold fs-5 text-white"
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            backgroundColor: "#41C1EE",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          {step.id}
                        </div>

                        {/* Step Content */}
                        <div className="step-content">
                          <h5 className="fw-bold mb-1">{step.title}</h5>
                          <p className="mb-0 text-dark">{step.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right: Image */}
              <div className="col-12 col-md-12 col-lg-6 text-center mt-lg-4">
                <img
                  src={
                    processSteps.find((step) => step.id === activeStep)?.image
                  }
                  alt={
                    processSteps.find((step) => step.id === activeStep)?.title
                  }
                  className="img-fluid rounded mb-3"
                  style={{
                    width: "100%",
                    maxHeight: "400px",
                    objectFit: "cover",
                    transition: "all 0.3s ease",
                  }}
                />
                <h5 className="fw-bold font-red">
                  Step {activeStep}:{" "}
                  {processSteps.find((step) => step.id === activeStep)?.title}
                </h5>
              </div>
            </div>
          </div>

          {/* <style>{`
          .process-steps {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
          }

          .process-step {
            display: flex;
            align-items: flex-start;
            padding: 2px;
            background: white;
            border-radius: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            border-left: 4px solid #e9ecef;
          }

          .process-step:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
          }

          .process-step.active {
            border-left-color: #41C1EE;
            background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
            box-shadow: 0 4px 20px rgba(13, 110, 253, 0.1);
          }

          .step-number {
            width: 25px;
            height: 25px;
            background: #e9ecef;
            color: #6c757d;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 1rem;
            margin-right: 1.5rem;
            flex-shrink: 0;
            transition: all 0.3s ease;
          }

          .process-step.active .step-number {
            background: #41C1EE;
            color: white;
            transform: scale(1.1);
          }

          .step-content {
            flex: 1;
          }

          .step-content h4 {
            color: #212529;
            margin-bottom: 0.5rem;
            transition: color 0.3s ease;
          }

          .process-step.active .step-content h4 {
            color: #41C1EE;
          }

          .step-content p {
            color: #6c757d;
            margin: 0;
            line-height: 1.6;
          }

          .image-container {
            padding: 1rem;
            border-radius: 12px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          }

          @media (max-width: 768px) {
            .row {
              flex-direction: column-reverse;
            }

            .sticky-top {
              position: static !important;
              margin-bottom: 2rem;
            }

            .process-step {
              padding: 1rem;
            }

            .step-number {
              width: 20px;
              height: 20px;
              margin-right: 1rem;
              font-size: 1rem;
            }
          }
        `}</style> */}
        </section>

        {/* Tools Section */}
        <section className="py-2 " style={{ marginTop: "20px" }}>
          <Container>
            <Row className="justify-content-center mb-2">
              <Col lg={8} className="text-center">
                <h3 className="display-5 fw-bold mb-3">
                  Marketing Technology <span className="font-red">Stack</span>
                </h3>
                <p className="font-para mb-4">
                  We leverage industry-leading tools to monitor performance,
                  refine strategies, and maximize your return on investment
                </p>
              </Col>
            </Row>

            <Row className="g-4">
              {marketingTools.map((tool, index) => (
                <Col lg={3} md={6} key={index}>
                  <div className="tool-card h-100 p-3 rounded-3 bg-white shadow-sm">
                    <div className="d-flex align-items-center mb-3">
                      <span className="fs-2 me-3">{tool.icon}</span>
                      <h3 className="h5 fw-bold mb-0">{tool.title}</h3>
                    </div>
                    <p className="mb-3">{tool.description}</p>
                    <div className="d-flex flex-wrap gap-2">
                      {tool.tools.map((t, idx) => (
                        <span key={idx} className="digital-badge px-2 py-1">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* CTA Section */}
        {/* <section className="py-6 text-dark"  style={{marginTop:'60px'}}>
        <Container>
          <Row className="align-items-center">
            <Col lg={8} className="mb-4 mb-lg-0">
              <h3 className="display-5 fw-bold mb-3">Ready to Transform Your Digital Presence?</h3>
              <p className="text-dark fw-semibold mb-4">
                Let's collaborate to create data-driven marketing campaigns that drive real business growth.
              </p>
            </Col>
            <Col lg={4} className="text-lg-end">
              <button className="btn btn-danger btn-lg px-4 py-3 fw-bold">
                Schedule a Strategy Session
              </button>
            </Col>
          </Row>
        </Container>
      </section> */}

        {/* Footer */}
        <Footer />

        {/* Custom Styles */}
        <style jsx={true} global>{`
          .marketing-hero {
            padding: 120px 0;
            position: relative;
            background-size: cover;
            background-position: center;
            overflow: hidden;
            height: 70px;
          }

          .marketing-hero .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;

            background-size: cover;
            opacity: 0.1;
          }

          .solution-card {
            background: white;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .solution-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          }

          .icon-container {
            width: 50px;
            height: 50px;
          }

          .stat-card {
            background: white;
            min-width: 140px;
            text-align: center;
          }

          .results-graph {
            background: white;
          }

          .graph-visualization {
            display: flex;
            align-items: flex-end;
            height: 200px;
            gap: 15px;
            padding: 20px 0;
          }

          .graph-bar {
            flex: 1;
            border-radius: 4px 4px 0 0;
            transition: height 0.5s ease;
          }

          .bg-gradient-light {
          }

          .feature-card {
            transition: transform 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-5px);
          }

          .feature-card .icon-container {
            width: 70px;
            height: 70px;
            background: #eef2ff;
            color: #41C1EE;
          }

          .process-steps {
            position: relative;
            max-width: 800px;
            margin: 0 auto;
          }

          .process-steps::before {
            content: "";
            position: absolute;
            top: 40px;
            left: 0;
            right: 0;
            height: 2px;
            background: #e5e7eb;
            z-index: 1;
          }

          .process-step {
            display: flex;
            margin-bottom: 40px;
            position: relative;
            z-index: 2;
          }

          .step-number {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: #41C1EE;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-weight: bold;
            flex-shrink: 0;
            margin-right: 30px;
            margin-left: 30px;
            margin-top: 10px;
          }

          .step-content {
            padding-top: 15px;
          }

          .tool-card {
            transition: transform 0.3s ease;
          }

          .tool-card:hover {
            transform: translateY(-5px);
          }

          .btn-primary {
            background: #4f46e5;
            border-color: #4f46e5;
          }

          .btn-primary:hover {
            background: #4338ca;
            border-color: #4338ca;
          }

          .btn-outline-light:hover {
            background: rgba(255, 255, 255, 0.1);
          }

          @media (max-width: 768px) {
            .marketing-hero {
              padding: 80px 0;
            }

            .display-4 {
              font-size: 2.5rem;
            }

            .process-steps::before {
              display: none;
            }

            .process-step {
              flex-direction: column;
              text-align: center;
              align-items: center;
              margin-bottom: 50px;
            }

            .step-number {
              margin-right: 0;
              margin-bottom: 20px;
            }
          }
        `}</style>
      </div>
    </HelmetProvider>
  );
};

export default DigitalMarketingPage;
